import Vue from 'vue'

// Ant Design Vue
import {
  Alert,
  AutoComplete,
  Badge,
  Button,
  Divider,
  Breadcrumb,
  Calendar,
  Card,
  Carousel,
  Collapse,
  DatePicker,
  Drawer,
  Dropdown,
  List,
  Input,
  InputNumber,
  Checkbox,
  Radio,
  Rate,
  Form,
  FormModel,
  Select,
  Slider,
  Switch,
  Skeleton,
  Spin,
  Space,
  Steps,
  TimePicker,
  Tag,
  Tabs,
  Table,
  Tooltip,
  Timeline,
  Modal,
  Menu,
  Progress,
  Pagination,
  Row,
  Col,
  Popover,
  Popconfirm,
  Empty
} from 'ant-design-vue'

Vue.use(Alert)
Vue.use(AutoComplete)
Vue.use(Badge)
Vue.use(Button)
Vue.use(Divider)
Vue.use(Breadcrumb)
Vue.use(Calendar)
Vue.use(Card)
Vue.use(Carousel)
Vue.use(Collapse)
Vue.use(DatePicker)
Vue.use(Dropdown)
Vue.use(Drawer)
Vue.use(List)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Checkbox)
Vue.use(Radio)
Vue.use(Rate)
Vue.use(Form)
Vue.use(FormModel)
Vue.use(Select)
Vue.use(Slider)
Vue.use(Switch)
Vue.use(Skeleton)
Vue.use(Spin)
Vue.use(Space)
Vue.use(Steps)
Vue.use(TimePicker)
Vue.use(Tag)
Vue.use(Tabs)
Vue.use(Table)
Vue.use(Tooltip)
Vue.use(Timeline)
Vue.use(Modal)
Vue.use(Menu)
Vue.use(Progress)
Vue.use(Pagination)
Vue.use(Row)
Vue.use(Col)
Vue.use(Popover)
Vue.use(Popconfirm)
Vue.use(Empty)
